import { OnboardingStatus } from "@enums/digital-audience/OnboardingStatus";
import { DigitalAudienceActions, DigitalAudienceActionsType } from "./DigitalAudienceActions";

export type DigitalAudienceState = {
  onboardingStatus: OnboardingStatus;
  isOnboardingStatusFetched: boolean;
};

const digitalAudienceState = (): DigitalAudienceState => ({
  onboardingStatus: OnboardingStatus.Unknown,
  isOnboardingStatusFetched: false
});

export const digitalAudienceReducer = (
  state: DigitalAudienceState = digitalAudienceState(),
  action: DigitalAudienceActions
): DigitalAudienceState => {
  
  switch (action.type) {
    case DigitalAudienceActionsType.SET_DIGITAL_AUDIENCE_ONBOARDING_STATUS: {
      return {
        ...state,
        onboardingStatus: action.payload.onboardingStatus
      }
    }

    case DigitalAudienceActionsType.SET_DIGITAL_AUDIENCE_ONBOARDING_STATUS_FETCHED: {
      return {
        ...state,
        isOnboardingStatusFetched: action.payload.isOnboardingStatusFetched
      }
    }

    default:
      return state;
  }
};